import { Box } from "@mui/material"
import type { CSSProperties } from "react"

export type IconUrlContainerProps = {
  url: string
  color?: CSSProperties["color"]
  style?: CSSProperties
  align?: "center" | "left" | "right"
  size?: string | number
}

export const IconUrlContainer = ({
  color = "currentColor",
  url,
  style = {},
  align = "center",
  size = "24px",
}: IconUrlContainerProps) => (
  <Box
    bgcolor={color}
    style={{
      width: style.width || size,
      height: style.height || size,
      mask: `url(${url}) center ${align} / contain no-repeat`,
      flexShrink: 0,
      ...style,
    }}
  />
)
